import(/* webpackMode: "eager" */ "/var/www/vibe/src/app/esqueci-senha/page.tsx");
